import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import useCurrentUser from '../../../hooks/useCurrentUser'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import {useAvailableSubscriptions} from '../hooks'
import SubscriptionEditor from './SubscriptionEditor'
import SubscriptionCreator from './SubscriptionCreator'
import Subscription from './Subscription'
import {
	sortSubscriptions,
	setActiveComponent,
	setEditor
} from './availableSubscriptionsSlice'
import {Link,useHistory} from 'react-router-dom'

import { DndProvider,useDrag,useDrop } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'


const ReorderModalPlaceholder = ({idx})=>{
	const dispatch = useDispatch()
	const [{canDrop,isOver}, drop] = useDrop(
		monitor => ({
			accept:'SUBSCRIPTION',
			drop: item => {
				const srcIdx = item.sort_order
				const tgtIdx = idx
				console.log(srcIdx,tgtIdx)
				dispatch(sortSubscriptions({
					srcIdx,
					tgtIdx,
				}))
			},
			collect: monitor => {
				const item = monitor.getItem()
				const canDrop = true
				return ({
					isOver: monitor.isOver(),
					canDrop,
				})
			}
		}),
	)
	return (
		<div 
			ref={drop} 
			style={{
				height:isOver&&canDrop?'18px':'4px',
				background:isOver&&canDrop?'blue':'transparent',
				transition:'0.1s',
				position:'relative'
			}}
		>
			<div
				style={{
					position:'absolute',
					height:isOver&&canDrop?'38px':'24px',
					width:'100%',
					top:'50%',left:0,
					transform:'translateY(-50%)'
				}}
			/>
		</div>
	)
}

const ReorderModalSubscription = ({subscription})=>{
	const [{ isDragging }, drag] = useDrag(() => ({
		type: 'SUBSCRIPTION',
		item:subscription,
		collect: (monitor) => ({
			isDragging: Boolean(monitor.isDragging())
		})
	}))
	return (
		<div ref={drag} className="w-100 bg-white py-1 px-3 border rounded">
			<i className="fa fa-grip-vertical mr-1" style={{cursor:'grab'}}/>
			{subscription.name}
		</div>
	)
}

const ReorderModal = ({show,onHide})=>{
	const {status,subscriptions} = useAvailableSubscriptions()
	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header>
				Re-order Subscriptions
			</Modal.Header>
			<Modal.Body>
				<DndProvider backend={HTML5Backend}>
					<ReorderModalPlaceholder idx={0}/>
					{subscriptions.map(
						(subscription,i) => <>
							<ReorderModalSubscription key={subscription.subscription_id} subscription={subscription}/>
							<ReorderModalPlaceholder key={`${subscription.subscription_id}-${i}`} idx={i+1}/>
						</>
					)}
				</DndProvider>
			</Modal.Body>
		</Modal>
	)
}

const AvailalbleSubscriptions = ()=>{
	const urlParams = new URLSearchParams(window.location.search)
	const filterId = parseInt(urlParams.get('subscription_id'))
	const history = useHistory()
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const {status,subscriptions} = useAvailableSubscriptions()
	const showEditor = useSelector( state => state.availableSubscriptions.editor.show )
	const [showReorderModal,setShowReorderModal] = useState(false)
	const {activeComponent} = useSelector(
		state => state.availableSubscriptions
	)

	if(status === 'pending') return <CenteredLoader/>

	const subscriptionsComponent = (
		<div>
			{isClient&&
				<div className="mb-2">
					<i className="fa fa-info-circle mr-1"/> 
					Subscriptions are charged to the card on file in <Link to="/billing">Billing</Link>.
				</div>
			}
			<div className="text-right mb-2">
				{!isClient&&
					<>
						<Button 
							className="mr-1"
							onClick={setShowReorderModal.bind(null,true)} 
							variant="outline-dark"
						>
							Reorder Subscriptions
						</Button>
						<Button variant="outline-success" onClick={()=>{
							dispatch(setActiveComponent('creator'))
						}}>
							Add Subscription
						</Button>
					</>
				}
			</div>
			{Boolean(filterId)&&
				<div className="mb-2">
					Viewing filtered list: 
					<Button 
						onClick={()=>{ 
							history.replace('/financials_dashboard/')
						}}
						variant="outline-danger" 
						className="ml-2"
						size="sm"
					>
						Clear Filters
					</Button>
				</div>
			}
			<div style={{
				display:'grid',
				gridGap:'8px',
				gridTemplateColumns:'repeat(auto-fit,minmax(350px,1fr))'
			}}>
				{subscriptions.filter(s=>!Boolean(filterId)||s.subscription_id===filterId).map(
					sub => <Subscription subscription={sub}/>
				)}
			</div>
			<ReorderModal
				show={showReorderModal}
				onHide={setShowReorderModal.bind(null,false)}
			/>
		</div>
	)

	switch(activeComponent){
		case 'subscriptions': return subscriptionsComponent
		case 'editor': return <SubscriptionEditor/>
		case 'creator': return <SubscriptionCreator/>
	}
}




export default AvailalbleSubscriptions